
import type { ReactNode } from "react";

import { cn } from "./cn";
import styles from "./Panel.module.css";

export type PanelProps = {
  title?: string;
  description?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  padding?: "none" | "md" | "lg";
  variant?: "default" | "sunken";
  headingLevel?: "h2" | "h3";
  className?: string;
  children: ReactNode;
};

export function Panel({
  title,
  description,
  actions,
  footer,
  padding = "md",
  variant = "default",
  headingLevel = "h2",
  className,
  children,
}: PanelProps) {
  const Heading = headingLevel;

  return (
    <section className={cn(styles.panel, variant === "sunken" && styles.sunken, className)}>
      {title || actions ? (
        <div className={styles.header}>
          <div className={styles.headerCopy}>
            {title ? <Heading className={styles.title}>{title}</Heading> : null}
            {description ? <p className={styles.description}>{description}</p> : null}
          </div>
          {actions ? <div className={styles.actions}>{actions}</div> : null}
        </div>
      ) : null}
      <div className={padding === "lg" ? styles.bodyLg : padding === "md" ? styles.bodyMd : undefined}>
        {children}
      </div>
      {footer ? <div className={styles.footer}>{footer}</div> : null}
    </section>
  );
}
